<template>
  <div class="py-3 container-fluid space-y-3">

    <!-- Grid de estadísticas -->
    <div class="grid grid-rows-4 md:grid-rows-2 md:grid-cols-2 lg:grid-rows-1 lg:grid-cols-4 gap-3">
      <div class="w-full bg-white rounded-lg p-3 flex items-center gap-2">
        <div class="flex items-center justify-center h-16 w-16 text-white rounded-md shadow bg-gradient-to-r from-[#424c42] to-[#647064]">
          <font-awesome-icon :icon="['far','handshake']" class="text-xl"/>
        </div>
        <div class="flex flex-col justify-start">
          <span class="text-sm font-light text-gray-600">{{ $t('dashboard.total.citas') }}</span>
          <span class="text-2xl font-bold leading-tight">{{ dashboardMeeting?.totalCitas }}</span>
          <span class="text-xs font-light text-gray-500">&nbsp;</span>
        </div>
      </div>
      <div class="w-full bg-white rounded-lg p-3 flex items-center gap-2">
        <div class="flex items-center justify-center h-14 w-14 text-white rounded-md shadow bg-gradient-to-r from-[#424c42] to-[#647064]">
          <font-awesome-icon :icon="['far','handshake']" class="text-xl"/>
        </div>
        <div class="flex flex-col justify-start">
          <span class="text-sm font-light text-gray-600">{{ $t('dashboard.citas.confirmadas') }}</span>
          <span class="text-2xl font-bold leading-tight">{{ dashboardMeeting?.totalConfirmadas }}</span>
          <span class="text-xs font-light text-gray-500">{{ porcentajeAprobacion }}% de confirmación</span>
        </div>
      </div>
      <div class="w-full bg-white rounded-lg p-3 flex items-center gap-2">
        <div class="flex items-center justify-center h-14 w-14 text-white rounded-md shadow bg-gradient-to-r from-[#424c42] to-[#647064]">
          <font-awesome-icon :icon="['far','handshake']" class="text-xl"/>
        </div>
        <div class="flex flex-col justify-start">
          <span class="text-sm font-light text-gray-600">{{ $t('dashboard.citas.pendientes') }}</span>
          <span class="text-2xl font-bold leading-tight">{{ dashboardMeeting?.totalPendientes }}</span>
          <span class="text-xs font-light text-gray-500">{{ porcentajeAprobacion }}% de pendientes</span>
        </div>
      </div>
      <div class="w-full bg-white rounded-lg p-3 flex items-center gap-2">
        <div class="flex items-center justify-center h-14 w-14 text-white rounded-md shadow bg-gradient-to-r from-[#424c42] to-[#647064]">
          <font-awesome-icon :icon="['far','handshake']" class="text-xl"/>
        </div>
        <div class="flex flex-col justify-start">
          <span class="text-sm font-light text-gray-600">{{ $t('dashboard.citas.rechazadas') }}</span>
          <span class="text-2xl font-bold leading-tight">{{ dashboardMeeting?.totalRechazadas }}</span>
          <span class="text-xs font-light text-gray-500">{{porcentajeRechazadas}}% de rechazo</span>
        </div>
      </div>
    </div>
    <!-- Fin Grid de estadísticas -->

    <!-- Grid pendientes-->
    <div v-if="dashboardMeeting?.pendientes?.length > 0" class="text-sm md:text-md text-gray-500">{{ $t('dashboard.acciones.pendientes') }}</div>
        
    <div class="flex flex-col lg:flex-row gap-3">
      <div v-for="(item, index) in dashboardMeeting?.pendientes" :key="index" class="flex-1">
        <router-link class="opacity-8" :to="getLink(item)">
          <div class=" bg-white rounded-lg p-4 flex items-center gap-3 cursor-pointer hover:bg-gray-200">
            <div class="flex items-center justify-center text-gray-600">
              <font-awesome-icon :icon="['far','fa-bell']" class="text-3xl fa-shake" />
            </div>
            <div class="flex flex-col">
              <span class="text-xs font-light text-gray-400">{{ item.tipo }}</span>
              <span class="text-sm leading-tight">{{ $t(item.descripcion) }}</span>
            </div>
          </div>
        </router-link>
      </div>
    </div>


    <!-- Timeline y citas por día -->
    <div v-if="dashboardMeeting?.proximasCitas?.length > 0" class="text-sm md:text-md text-gray-500">{{ $t('dashboard.proximas.citas') }}</div>
    <div class="flex flex-col gap-2">
      <div v-for="(item, index) in dashboardMeeting?.proximasCitas" :key="index" class="w-full bg-white rounded-lg p-3 flex items-center gap-2">
        <div class="flex items-center justify-center h-16 w-16 rounded-md border" :style="{ borderColor: item.estadoAgenda.color, color: item.estadoAgenda.color }">
          <font-awesome-icon :icon="getIcono(item)" class="text-3xl"/>
        </div>
        <div class="flex flex-col justify-start">
          <span class="text-sm font-bold text-gray-600">{{ item.cronograma?.horaDesde }}</span>
          <span class="text-sm font-light text-gray-600">{{ formatDate(item?.cronograma?.fecha, 'dd/MM/yyyy') }}</span>
          <div class="flex flex-wrap text-xs font-semibold" :style="{ color: item.estadoAgenda.color }">
            {{ $t(item?.estadoAgenda?.descripcion) }}
          </div>
        </div>
      </div>
    </div>

    <FullScreenLoader :visible="isSubmitting" />

  </div>

</template>

<script lang="ts">
import { defineComponent } from 'vue';

import Swal from 'sweetalert2'
import FullScreenLoader from '@/components/commons/FullScreenLoader.vue';

import meetingService, { ConfiguracionMeeting } from 'qreventos-suite/meeting';
import configuracionMeetingService from '@/services/configuracion.merting.services';
import seguridadServices from '@/services/seguridad.services';
import { Agenda, DashboardMeeting, PendienteMeeting } from 'qreventos-suite/src/services/suite.interfaces';
import { formatDate } from 'date-fns';

export default defineComponent({
  components: {
    FullScreenLoader,
  },
  data() {
    return {
      isSubmitting: false,
      dashboardMeeting: undefined as unknown as DashboardMeeting,
      porcentajeAprobacion: 0,
      porcentajePendientes: 0,
      porcentajeRechazadas: 0      
    };
  },
  methods: {
    formatDate,
    getLink(item: PendienteMeeting):string {
      if (item.tipo == "PERFIL") {
        return "/private/perfil";
      } else if (item.tipo == "AGENDA") {
        return "/private/agenda";
      }
      return "";
    },
    async fillDashbaord() {
      const hash: string = seguridadServices.getLocalHash() as string;
      const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;
      this.dashboardMeeting = await meetingService.findDashboarBy(configuracionMeeting.evento.id, hash);
      if (this.dashboardMeeting) {
        this.porcentajeAprobacion = (this.dashboardMeeting.totalCitas * this.dashboardMeeting.totalConfirmadas) / 100;
        this.porcentajePendientes = (this.dashboardMeeting.totalCitas * this.dashboardMeeting.totalPendientes) / 100;
        this.porcentajeRechazadas = (this.dashboardMeeting.totalCitas * this.dashboardMeeting.totalRechazadas) / 100;
      }
    },
    getIcono(item:Agenda): any {
      switch (item.estadoAgenda.id) {
        case 1:
          return ['far', 'clock'];
        case 2:
          return ['fas', 'check'];
        case 3:
          return ['fas', 'times'];
        case 4:
          return ['fas', 'lock'];
        case 5:
          return ['fas', 'calendar'];
      }
    },    
  },
  async mounted() {
    try {
      this.isSubmitting = true;

      await this.fillDashbaord();

    } catch (error) {
      this.isSubmitting = false;
      Swal.fire({ title: "Error", text: error + '', icon: "error" });
    } finally {
      this.isSubmitting = false;
    }

  },
});
</script>
